import { FaCompass, FaTree, FaUsers } from "react-icons/fa";

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Experience the Wilderness with Us",
    content: "At our outdoor adventure club, we are dedicated to providing unforgettable experiences and fostering a deep connection with the wilderness.",
    points: [
        {
            id: 1,
            icon: <FaTree />,
            title: 'Nature Immersion',
            content: "Immerse yourself in the untamed beauty of nature and discover hidden trails, breathtaking vistas, and serene camping spots on our guided expeditions.",
        },
        {
            id: 2,
            icon: <FaCompass />,
            title: 'Expert Guidance',
            content: "Learn essential outdoor skills and navigation techniques from our experienced guides who are passionate about sharing their knowledge and ensuring your safety on every trek.",
        },
        {
            id: 3,
            icon: <FaUsers />,
            title: 'Adventure Community',
            content: "Join our vibrant community of outdoor adventurers and forge lasting connections with fellow hikers, campers, and trekkers. Share stories, swap tips, and embark on epic journeys together.",
        },
    ]
};

export default whyChooseUs;